/*
 * @Author: puxiao.wh
 * @Date: 2019-01-10 22:56:59
 * @LastEditors: puxiao.wh
 * @LastEditTime: 2019-01-22 14:54:58
 * @Description: 
 */

import Rqx from './rqx'
import olfactory from './olfactory'
import scrollend from './scrollend'
const { isDebug } = window.jplusUtil

// 是否继续执行
function expShouldRecord(config, ele, props) {
    if (config.expShouldRecord) {
        return config.expShouldRecord(config, ele, props)
    }
    return true
}
// 请求之前对数据进行加工，返回值为新值
function expWillRecord(config, ele, props) {
    if (config.expWillRecord) {
        return config.expWillRecord(config, ele, props)
    }
    return config
}
// 请求发送后调用，但不确保请求成功
function expDidRecord(config, ele, props, data) {
    if (config.expDidRecord) {
        return config.expDidRecord(config, ele, props, data)
    }
    return config
}

const jplugPluginExp = {
    record(config, ele, props, configList) {
        if (expShouldRecord(config, ele, props)) {
            const newConfig = Object.assign({}, expWillRecord(config, ele, props))
            const url = newConfig.url
            const method = newConfig.method
            const postSize = newConfig.postSize

            if (url) {
                if (method === 'get') {
                    Rqx.$get(url)
                    expDidRecord(newConfig, newConfig.ele, newConfig.props)
                    ele.setAttribute(newConfig.tagName, 'true')

                    if(isDebug) {
                        console.group('jplus-plugin-exp，信息提示')
                            console.info('Get请求上报成功')
                            console.log('上报地址：', url)
                            console.log('元素节点：', ele)
                            if(configList) {
                                console.log('返回参数：', configList)
                            } else {
                                console.log('返回参数：', config)
                            }
                        console.groupEnd()
                    }
                } else if (method === 'post') {
                    if (Array.isArray(window.jplus.plugin.exp[newConfig.groupIndex].postDataList)) {
                        window.jplus.plugin.exp[newConfig.groupIndex].postDataList.push(url)
                    } else {
                        window.jplus.plugin.exp[newConfig.groupIndex].postDataList = [url]
                    }
                    ele.setAttribute(newConfig.tagName, 'true')

                    // 缓存策略
                    scrollend.watch(() => {
                        window.jplus.plugin.exp.map((item, index) => {
                            const config = configList[index]
                            let dataList = []
                            if (postSize === 'max') {
                                dataList = window.jplus.plugin.exp[index].postDataList
                                window.jplus.plugin.exp[index].postDataList = []
                            } else {
                                dataList = window.jplus.plugin.exp[index].postDataList.splice(0, postSize)
                            }
                            if (dataList.length !== 0) {
                                Rqx.$post(config.postUrl, {
                                    [config['postParams']]: dataList
                                })
                                expDidRecord(config, config.ele, config.props, {
                                    [config['postParams']]: dataList
                                })
                                if(isDebug) {
                                    console.group('jplus-plugin-exp，信息提示')
                                        console.info('Post请求上报成功')
                                        console.log('上报地址：', dataList)
                                        console.log('元素节点：', ele)
                                        if(configList) {
                                            console.log('返回参数：', configList)
                                        } else {
                                            console.log('返回参数：', config)
                                        }
                                    console.groupEnd()
                                }
                            }
                        })
                    })
                }
            } else {
                if(isDebug) {
                    console.group('jplus-plugin-exp，信息提示')
                        console.warn('缺少上报地址')
                        console.log('元素节点：', ele)
                        if(configList) {
                            console.log('返回参数：', configList)
                        } else {
                            console.log('返回参数：', config)
                        }
                    console.groupEnd()
                } else {
                    console.warn(`存在错误信息，请使用该链接访问查看错误: ${location.href}&_jplusDebugModel_=1`)
                }
            }
        }
    }
}

new olfactory(jplugPluginExp)

export default {
    olfactory,
    jplugPluginExp
}
